const ENDPOINT = "/api/fast/analytics/track";

export async function track(event, properties = {}, context = {}) {
  if (!event) return;
  try {
    const payload = {
      event,
      properties,
      context: {
        path: window.location.pathname,
        search: window.location.search,
        referrer: document.referrer || "",
        title: document.title || "",
        ...context
      }
    };
    await fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
  } catch {
    // Best effort
  }
}

export function trackPageView() {
  track("page_view");
}
